import { initializeApp } from 'firebase/app'
import { getAuth } from 'firebase/auth'
import { getFunctions, httpsCallable } from 'firebase/functions'
import { reportError } from '../utils/telemetry'

let firebaseConfig
try {
  firebaseConfig = JSON.parse(import.meta.env.VITE_FIREBASE_CONFIG)

  // Validate required fields
  if (!firebaseConfig.apiKey) {
    throw new Error('Firebase config missing required field: apiKey')
  }
  if (!firebaseConfig.projectId) {
    throw new Error('Firebase config missing required field: projectId')
  }
} catch (error) {
  console.error(
    'Failed to parse or validate Firebase configuration:',
    error.message,
  )
  throw new Error(`Invalid Firebase configuration: ${error.message}`)
}

export const firebaseApp = initializeApp(firebaseConfig)
export const auth = getAuth(firebaseApp)
export const firebaseFunctions = getFunctions(
  firebaseApp,
  'australia-southeast1',
)

export const addClaimToToken = async () => {
  const functions = getFunctions(firebaseApp, 'australia-southeast1')
  const user = auth.currentUser

  if (!user?.uid) {
    reportError(`User id not found with email: ${user?.email}`)
    throw new Error('User id not found')
  }
  const addClaimFunction = httpsCallable(functions, 'rubix-addRubixClaim')
  await addClaimFunction({ uid: user.uid, userEmail: user?.email })
}

export const getCurrentUser = () => {
  return new Promise((resolve, reject) => {
    const unsub = auth.onAuthStateChanged(
      user => {
        resolve(user)
        unsub()
      },
      error => {
        reject(error)
      },
    )
  })
}
